var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.$props.itemDetail.componentSubcode === "l_ts_1"
      ? _c(
          "div",
          {
            staticStyle: {
              display: "flex",
              "justify-content": "space-between",
              "align-items": "center",
            },
          },
          [
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "justify-content": "flex-start",
                  "align-items": "center",
                  flex: "1",
                },
              },
              [
                _c("div", { staticStyle: { margin: "0 10px 0 0" } }, [
                  _c("i", {
                    staticClass: "el-icon-location-outline",
                    style: { color: _vm.localTopSearchStyle.positionColor },
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      style: {
                        fontSize: "12px",
                        color: _vm.localTopSearchStyle.positionColor,
                      },
                    },
                    [_vm._v("定位")]
                  ),
                ]),
                _vm._v(" "),
                _c("div", {
                  staticClass: "s-box",
                  style: {
                    borderRadius:
                      _vm.localTopSearchStyle.style == 1 ? "6px" : "20px",
                  },
                }),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "justify-content": "space-between",
                },
              },
              _vm._l(_vm.dataList, function (item, index) {
                return _c("img", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: item.status === 1,
                      expression: "item.status===1",
                    },
                  ],
                  key: index,
                  staticStyle: { height: "25px", "margin-left": "10px" },
                  attrs: {
                    src: item.bannerPic
                      ? item.bannerPic
                      : require("@/assets/customPage/tp_icon.png"),
                  },
                })
              }),
              0
            ),
          ]
        )
      : _c("div", [
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "space-between",
                "align-items": "center",
              },
            },
            [
              _c("div", { staticStyle: { margin: "0 10px 0 0" } }, [
                _c("i", {
                  staticClass: "el-icon-location-outline",
                  style: { color: _vm.localTopSearchStyle.positionColor },
                }),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    style: {
                      fontSize: "12px",
                      color: _vm.localTopSearchStyle.positionColor,
                    },
                  },
                  [_vm._v("定位")]
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "space-between",
                  },
                },
                _vm._l(_vm.dataList, function (item, index) {
                  return _c("img", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: item.status === 1,
                        expression: "item.status===1",
                      },
                    ],
                    key: index,
                    staticStyle: { height: "25px", "margin-left": "10px" },
                    attrs: {
                      src: item.bannerPic
                        ? item.bannerPic
                        : require("@/assets/customPage/tp_icon.png"),
                    },
                  })
                }),
                0
              ),
            ]
          ),
          _vm._v(" "),
          _c("div", {
            staticClass: "s-box",
            style: {
              borderRadius: _vm.localTopSearchStyle.style == 1 ? "6px" : "20px",
              marginTop: "5px",
            },
          }),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }